var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1085_20120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28C14.9241 28 13.3637 27.6896 11.9078 27.0866C10.4519 26.4835 9.12902 25.5996 8.01472 24.4853C6.90042 23.371 6.0165 22.0481 5.41345 20.5922C4.81039 19.1363 4.5 17.5759 4.5 16C4.5 14.4241 4.81039 12.8637 5.41345 11.4078C6.0165 9.95189 6.90042 8.62902 8.01472 7.51472C9.12902 6.40042 10.4519 5.5165 11.9078 4.91345C13.3637 4.31039 14.9241 4 16.5 4C19.6826 4 22.7348 5.26428 24.9853 7.51472C27.2357 9.76516 28.5 12.8174 28.5 16C28.5 19.1826 27.2357 22.2348 24.9853 24.4853C22.7348 26.7357 19.6826 28 16.5 28Z",
    stroke: "#7494FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.832 13.332C13.1654 11.9987 10.4987 11.9987 9.83203 13.332",
    stroke: "#7494FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.168 13.332C22.5013 11.9987 19.8346 11.9987 19.168 13.332",
    stroke: "#7494FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8346 20C19.4001 20.4435 18.8815 20.7958 18.3091 21.0363C17.7368 21.2768 17.1222 21.4007 16.5013 21.4007C15.8805 21.4007 15.2658 21.2768 14.6935 21.0363C14.1211 20.7958 13.6025 20.4435 13.168 20",
    stroke: "#7494FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1085_20120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmile);
export default __webpack_public_path__ + "static/media/icon-smile.eef34f83971b0bc9cd79137ab45deef0.svg";
export { ForwardRef as ReactComponent };